import React from 'react'
import {ChevronDownIcon} from '@primer/octicons-react'
import type {Icon} from '@primer/octicons-react'
import type {ComponentPropsWithRef} from 'react'
import {clsx} from 'clsx'
import {DisclosureContext} from './disclosure-context'
import styles from './DisclosureChevron.module.css'

export interface DisclosureChevronProps extends Omit<ComponentPropsWithRef<'span'>, 'children'> {
  icon?: Icon
  size?: number
  openRotation?: number
  closedRotation?: number
}

export const DisclosureChevron = ({
  icon: Icon = ChevronDownIcon,
  size,
  openRotation = 180,
  closedRotation = 0,
  className,
  style,
  ref,
  ...rest
}: DisclosureChevronProps) => {
  const disclosureContextValue = React.use(DisclosureContext)

  if (!disclosureContextValue) throw new Error('Disclosure.Chevron must be rendered inside Disclosure')

  return (
    <span
      {...rest}
      ref={ref}
      aria-hidden="true"
      data-open={disclosureContextValue.open}
      className={clsx(styles.chevron, className)}
      style={{
        ...style,
        '--_disclosure-chevron-rotation-closed': `${closedRotation}deg`,
        '--_disclosure-chevron-rotation-open': `${openRotation}deg`,
        '--_disclosure-chevron-duration': `${Math.round((Math.abs(openRotation - closedRotation) / 180) * 150)}ms`,
      }}
    >
      <Icon size={size} />
    </span>
  )
}
